import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Div, H1 } from 'components/Ui';
import { dataLayerPush } from 'utils/tracking';
import { translateData, getToUrl } from 'utils/translation';
import { PromoPart, PROMOS } from 'components/Promos';
import { PROMO_NAME } from 'containers/QuickShop/constants';
import { ArrowRightBlue, PromotionBlackIcon } from 'images';
import PromotionValidation from './PromotionValidation';
import styles from './styles.scss';

const SubHeader = ({
  title,
  showPromotionRedeemer,
  promotionNote,
  addPromotion,
  showSkipButton,
  skipButtonText,
  skipButtonLabel,
  skipButtonColor,
  onNext,
  promotionApplied,
  cartItems,
  activeStep,
  showRedeemDialog,
  costco,
  isCostco,
}) => {
  const step = activeStep + 1;
  const applyPromotion = () => {
    // mmm ppp promotionClick - Done dlA37 - Quick Shop > SubHeader > Redeem (No Data Layer Push)
    dataLayerPush(
      'Acquisition',
      {
        event: 'promotionClick',
        ecommerce: {
          promoClick: {
            promotions: [
              {
                name: PROMO_NAME,
                position: 'Quick Shop Step 1 Offers Bar',
              },
            ],
          },
        },
      },
      'dlA37',
      'PUSH_ADD_PROMOTION_DATA',
      showRedeemDialog,
    );
    addPromotion();
  };

  return (
    <div className={styles.subHeader}>
      <H1 className={styles.title}>{isCostco ? costco.title : title}</H1>
      {showSkipButton && (
        <div className={styles.skipStep}>
          {translateData(skipButtonText)}
          {isCostco ? (
            <Link to={getToUrl('/cart', 'U38')}>
              {skipButtonLabel}
              <img className={styles.imgRight} src={ArrowRightBlue} alt="" />
            </Link>
          ) : (
            <PromotionValidation
              buttonLabel={skipButtonLabel}
              buttonColor={skipButtonColor}
              promotionApplied={promotionApplied}
              onNext={onNext}
              step={step}
              cartItems={cartItems}
              reviewCart
              showIcon
            />
          )}
        </div>
      )}
      {showPromotionRedeemer ||
        (!isCostco && !showSkipButton && (
          <PromoPart promo={PROMOS.FullPressGuided}>
            <div className={styles.promotionRedeem}>
              <img
                className={styles.promotionIcon}
                src={PromotionBlackIcon}
                alt=""
              />
              <Div className={styles.primaryNote}>{promotionNote.title}</Div>
              <Button
                className={styles.button}
                text={promotionNote.buttonLabel}
                onClick={applyPromotion}
                disabled={false}
              />
            </div>
          </PromoPart>
        ))}
    </div>
  );
};

SubHeader.propTypes = {
  title: PropTypes.string.isRequired,
  showPromotionRedeemer: PropTypes.bool,
  promotionNote: PropTypes.object,
  addPromotion: PropTypes.func,
  showSkipButton: PropTypes.bool,
  skipButtonText: PropTypes.string,
  skipButtonLabel: PropTypes.string,
  skipButtonColor: PropTypes.string,
  onNext: PropTypes.func,
  promotionApplied: PropTypes.bool,
  cartItems: PropTypes.array,
  activeStep: PropTypes.number,
  showRedeemDialog: PropTypes.func,
  isCostco: PropTypes.bool,
  costco: PropTypes.object,
};

export default SubHeader;
